import {App3D} from './App3D';

import * as _ from "lodash";

export enum LogLevel {
	Error = 0,
	Warnign,
	Debug,
	Verbose
}

export class Logger {
	public showLocation: boolean = false;

	readonly catgColors = {
		error: '#dd1100',
		warning: '#dd9900',
		load: '#0077dd'
	};

	readonly st_line = 'color: #777777; text-align: right; float:right;';	// line number
	readonly st_main = 'color: #cfcfcf;'; // message

	constructor(
			protected app3D: App3D,
			public log_level: number = LogLevel.Warnign,
			public log_opts: any = '-') {
		switch (this.log_opts) {
			case '*':
			case 'all':
				this.log_opts = '*';
				break;
			case '-':
			case 'none':
				this.log_opts = '-';
				break;
			default:
				if (!Array.isArray(this.log_opts)) {
					this.log_opts = null;
				}
		}
	}

	// Get location of function call in code
	protected getLoc(): string {
		if (!this.showLocation)
			return '';
		function getErrorObject() {
			try { // noinspection ExceptionCaughtLocallyJS
				throw Error('')
			} catch (err) {
				return err;
			}
		}

		let err = getErrorObject();
		let caller_line = err.stack.split("\n")[3];
		let index = caller_line.indexOf("at ");
		return '%c'+caller_line.slice(index + 2, caller_line.length).split('/').pop();
	}

	log(data: any, opt: string | number = LogLevel.Debug, group = null) {
		if (typeof opt === 'number')
			this.logLevel(data, Number(opt));
		else
			this.logCategory(data, opt, group);
	}

	error(data){
		this.logLevel(data, LogLevel.Error);
	}
	warn(data){
		this.logLevel(data, LogLevel.Warnign);
	}
	debug(data){
		this.logLevel(data, LogLevel.Debug);
	}
	info(data){
		this.logLevel(data, LogLevel.Verbose);
	}

	logLevel(data: any, level: number = LogLevel.Debug) {
		if (level > this.log_level)
			return;
		this.dump(data);
	}

	logCategory(data, category: string = null, group = null): void {
		if (
				(this.log_opts != '*') && (
						// (this.app3D.$.inArray(this.log_opts, excluded) >= 0) ||
						(category && (!this.log_opts || (this.app3D.$.inArray(category, this.log_opts) < 0))))) // category is defined, but not in flag list
			return;
		this.dump(data, category, group);
	}

	protected dump(data: any, category: string = null, group = null): void {
		let loc = this.getLoc();
		if ((typeof data === 'object') && !group)
			group = true;

		// nest
		if (group) {
			if (group === true)
				group = '';
			if (category)
				console.groupCollapsed(category + ' ' + group + loc);
			else
				console.groupCollapsed(group + loc);
			// console.groupCollapsed('%c'+group + loc, st_catg, st_line);	// browser specific - do not use :(
			if (Array.isArray(data))
				_.each(data, function (line) {
					console.log(line);
				});
			else
				console.dir(data);
			console.groupEnd();
		}
		else {
			let args = [(category ? '%c' + category : '') + '%c'+data + loc];
			if (category)	// colorize category
				args.push('color: #ffffff; padding: 2px; background: ' + (this.catgColors.hasOwnProperty(category)
						? this.catgColors[category]
						: '#0044ff') + '; margin-right: 3px;');
			args.push(this.st_main);
			if (this.showLocation)
				args.push(this.st_line);
			console.log.apply(this, args);
		}
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/Logger.ts